// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"vp-z","outfitFeedbackSection":"wp-z"};